import { render, staticRenderFns } from "./BaseLocationViewModal.vue?vue&type=template&id=0c30d80a&scoped=true&"
import script from "./BaseLocationViewModal.vue?vue&type=script&lang=js&"
export * from "./BaseLocationViewModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseLocationViewModal.vue?vue&type=style&index=0&id=0c30d80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30d80a",
  null
  
)

export default component.exports